import { SAMPLE_IDX } from '../data/videoTemplates';
import { Modal } from '../components/Modal';
import { Icon } from '../components/Icon';
import './PickerPopups.css';

// There is no device upload: the source is the scene's sample or a photo the user generated here.
export function ImagePickerPopup({ isOpen, onClose, sampleUrl, photos, selectedImage, onSelect, onCreatePhoto }) {
    const pick = (img) => { onSelect(img); onClose(); };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" title="Choose image" subtitle="Use the sample or one of your generated photos">
            <div className="pickGrid">
                <button type="button" className="pickTile pickTile--create" onClick={onCreatePhoto}>
                    <span className="pickTilePlus"><Icon name="plus" size={22} strokeWidth={2.4} /></span>
                    <span>Create new photo</span>
                </button>
                {sampleUrl && (
                    <button
                        type="button"
                        className={`pickTile${selectedImage?.id === 'sample' ? ' pickTile--selected' : ''}`}
                        onClick={() => pick({ id: 'sample', url: sampleUrl, type: 'sample', sampleIdx: SAMPLE_IDX })}
                    >
                        <img src={sampleUrl} alt="Sample" />
                        <span className="badge pickTileBadge">Sample</span>
                        {selectedImage?.id === 'sample' && <span className="tplCardCheck"><Icon name="check" size={14} strokeWidth={3} /></span>}
                    </button>
                )}
                {photos.map((photo, idx) => {
                    const selected = selectedImage?.type === 'user' && selectedImage.url === photo.url;
                    return (
                        <button
                            key={photo.media_id || idx}
                            type="button"
                            className={`pickTile${selected ? ' pickTile--selected' : ''}`}
                            onClick={() => pick({ type: 'user', url: photo.url, mediaId: photo.media_id })}
                        >
                            <img src={photo.url} alt="" loading="lazy" />
                            {selected && <span className="tplCardCheck"><Icon name="check" size={14} strokeWidth={3} /></span>}
                        </button>
                    );
                })}
            </div>
        </Modal>
    );
}
